import { z } from 'zod';
import { amountSchema } from '../common/amount.js';
import { paginationMetaSchema } from '../common/pagination.js';
import { branchRefSchema, employeeRefSchema } from '../common/refs.js';
import { balanceStatusSchema, debtorRefSchema, exportLocaleShape, ledgerRowSchema, movementKindFilterSchema, movementTotalsSchema, pageQueryShape, periodIsOrdered, periodQueryShape, PERIOD_ORDER_ISSUE, } from './common.js';
/** التقارير (debts.md section 12). كشف العميل is the statement of section 7. */
export const REPORT_EXPORT_FORMATS = ['xlsx', 'pdf'];
const periodMovementsFilterShape = {
    /** Required on the page; an absent bound defaults to today (Asia/Amman). */
    ...periodQueryShape,
    branchId: z.string().trim().min(1).optional(),
    kind: movementKindFilterSchema.optional(),
    /** The local user who entered the movements. */
    employeeId: z.string().trim().min(1).optional(),
    /** العميل: the movements of that debtor's accounts. */
    debtorId: z.string().trim().min(1).optional(),
    /** الحساب, after a debtor is chosen. */
    accountId: z.string().trim().min(1).optional(),
};
/** حركات الفترة. */
export const periodMovementsQuerySchema = z
    .object({ ...periodMovementsFilterShape, ...pageQueryShape })
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
export const periodMovementsExportQuerySchema = z
    .object({
    ...periodMovementsFilterShape,
    ...exportLocaleShape,
    format: z.enum(REPORT_EXPORT_FORMATS).default('xlsx'),
})
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
export const periodMovementsSchema = z.object({
    period: z.object({ from: z.string(), to: z.string() }),
    items: z.array(ledgerRowSchema),
    meta: paginationMetaSchema,
    totals: z.object({
        branches: z.array(z.object({ branch: branchRefSchema, totals: movementTotalsSchema })),
        overall: movementTotalsSchema,
    }),
});
const customerBalancesFilterShape = {
    branchId: z.string().trim().min(1).optional(),
    balanceStatus: balanceStatusSchema.optional(),
};
/** أرصدة العملاء. */
export const customerBalancesQuerySchema = z.object({
    ...customerBalancesFilterShape,
    ...pageQueryShape,
});
export const customerBalancesExportQuerySchema = z.object({
    ...customerBalancesFilterShape,
    ...exportLocaleShape,
    format: z.enum(REPORT_EXPORT_FORMATS).default('xlsx'),
});
/** One account; rows of one debtor sit together, by debtor name then account name. */
export const customerBalanceRowSchema = z.object({
    id: z.string(),
    number: z.number().int(),
    /** اسم الحساب. */
    name: z.string(),
    debtor: debtorRefSchema,
    /** The debtor's phone, or the account's legacy phone text. */
    phone: z.string().nullable(),
    branch: branchRefSchema,
    balance: amountSchema,
    debtLimit: amountSchema.nullable(),
    /** تاريخ آخر حركة. */
    lastMovementAt: z.string().nullable(),
});
/** عليه رصيد (count and sum), له رصيد (count and sum) and the net. */
export const balanceTotalsSchema = z.object({
    owesCount: z.number().int().nonnegative(),
    owesSum: amountSchema,
    owedCount: z.number().int().nonnegative(),
    owedSum: amountSchema,
    net: amountSchema,
});
export const customerBalancesSchema = z.object({
    items: z.array(customerBalanceRowSchema),
    meta: paginationMetaSchema,
    totals: z.object({
        branches: z.array(z.object({ branch: branchRefSchema, totals: balanceTotalsSchema })),
        overall: balanceTotalsSchema,
    }),
});
/** The الموظف filter of حركات الفترة: employees who entered movements in the user's branches. */
export const reportEmployeesSchema = z.array(employeeRefSchema);
//# sourceMappingURL=reports.js.map